import React from 'react';
import { hot } from 'react-hot-loader';
import Newsletter from '../../Footer/Newsletter';
import Breadcrumbs from '../../Category/Breadcrumbs';
import s from './Placeholder.scss';

const Placeholder = ({ content }) => {
	if (content.placeholder === 'newsletter') {
		return <div className={s.newsletter}><Newsletter expanded /></div>;
	}
	if (content.placeholder === 'breadcrumbs') {
		return <Breadcrumbs />;
	}

	return null;
};

export default hot(module)(Placeholder);
